import { z } from 'zod'

export const paymentInstrumentSnapshotSchema = z.object({
  cardName: z.string().nullish(),
  cardLast4: z.string().nullish(),
  cardType: z.string().nullish(),
  cardImageUrl: z.string().nullish(),
  paymentMethodType: z.string().nullish(),
  walletType: z.string().nullish(),
  cardFunding: z.string().nullish(),
  cardCountry: z.string().nullish(),
  expirationMonth: z.string().nullish(),
  expirationYear: z.string().nullish(),
})
